export type ProductAvailability = 'available' | 'sold-out' | 'unavailable'

export type Product = {
  id: string
  name: string
  category: 'Brownie Cookie Sandwich' | 'Stuffed Cookie' | 'Brownie'
  image: string
  isNew: boolean
  presentation: string
  shortDescription?: string
  availability?: ProductAvailability
  orderVisible?: boolean
  boxEligible?: boolean
  badge?: string
  displayOrder?: number
}

export type Offer = {
  quantity: number
  price: number
}

export const weeklyDrop = {
  announcement: "THIS WEEKS DROP IS LIVE - ORDER BY FRI 6PM FOR SAT & SUN DELIVERY",
  offers: [
    { quantity: 4, price: 30 },
    { quantity: 6, price: 40 },
  ] satisfies Offer[],
  orderClose: 'Orders close Friday 6pm each week.',
  deliveryWindow: 'Saturday & Sunday, 3pm – 6pm.',
  deliveryAreas: 'Up to 35 km from our Christchurch delivery base.',
  payment: 'Card or bank transfer.',
}

export const socialLinks = [
  { label: 'Facebook', href: 'https://www.facebook.com/sugargremlinnz', icon: '/assets/icons/social/facebook.svg' },
  { label: 'Instagram', href: 'https://www.instagram.com/sugargremlinnz/', icon: '/assets/icons/social/instagram.svg' },
] as const

export const products: Product[] = [
  { id: 'chocolate', name: 'CHOCOLATE', category: 'Brownie Cookie Sandwich', image: '/assets/products/sg-product-chocolate.png', isNew: true, presentation: '#5b3128' },
  { id: 'vanilla', name: 'VANILLA', category: 'Brownie Cookie Sandwich', image: '/assets/products/sg-product-vanilla.png', isNew: false, presentation: '#f0d49f' },
  { id: 'peppermint', name: 'PEPPERMINT', category: 'Brownie Cookie Sandwich', image: '/assets/products/sg-product-peppermint.png', isNew: false, presentation: '#8abf9f' },
  { id: 'boysenberry', name: 'BOYSENBERRY', category: 'Brownie Cookie Sandwich', image: '/assets/products/sg-product-boysenberry.png', isNew: false, presentation: '#754052' },
  { id: 'biscoff-cheesecake', name: 'BISCOFF & CHEESECAKE', category: 'Stuffed Cookie', image: '/assets/products/sg-product-biscoff-cheesecake.png', isNew: false, presentation: '#c48b53' },
  { id: 'og-chocolate', name: 'OG CHOCOLATE', category: 'Stuffed Cookie', image: '/assets/products/sg-product-og-chocolate.png', isNew: false, presentation: '#6d4032' },
  { id: 'banana-bread', name: 'BANANA BREAD', category: 'Stuffed Cookie', image: '/assets/products/sg-product-banana-bread.png', isNew: false, presentation: '#c49449' },
]

export const goodToKnow = [
  { label: 'ORDER WINDOW', value: weeklyDrop.orderClose, icon: '/assets/icons/sg-ui-calendar.svg' },
  { label: 'DELIVERY WINDOW', value: weeklyDrop.deliveryWindow, icon: '/assets/icons/sg-ui-truck.svg' },
  { label: 'DELIVERY AREAS', value: weeklyDrop.deliveryAreas, icon: '/assets/icons/sg-ui-map-pin.svg' },
  { label: 'PAYMENT', value: weeklyDrop.payment, icon: '/assets/icons/sg-ui-credit-card.svg' },
]

export const difference = [
  { title: 'SMALL BATCH', body: 'Baked in our Christchurch kitchen, in small batches.', image: '/assets/homepage/sg-difference-small-batch.webp' },
  { title: 'REAL INGREDIENTS', body: 'The good stuff. No shortcuts, ever.', image: '/assets/homepage/sg-difference-real-ingredients.webp' },
  { title: 'WEEKLY DROPS', body: 'New flavours (and aces) each week.', image: '/assets/homepage/sg-difference-weekly-drops.webp' },
  { title: 'MADE WITH LOVE', body: 'By real humans, with a lot of love (and a bit of chaos).', image: '/assets/homepage/sg-difference-made-with-love.webp' },
]

export const howItWorks = [
  { step: '1', title: 'PICK YOUR FAVES', body: "Browse this week's menu and build your box.", image: '/assets/homepage/sg-how-pick-your-faves.webp' },
  { step: '2', title: 'WE BAKE FRESH', body: 'We bake to order, just for you.', image: '/assets/homepage/sg-how-we-bake-fresh.webp' },
  { step: '3', title: 'DELIVERED TO YOU', body: 'Delivery up to 35 km from our Christchurch delivery base.', image: '/assets/homepage/sg-how-delivered-to-you.png' },
]
